import { frontendURL } from 'dashboard/helper/URLHelper';
import PointOfSaleView from './PointOfSaleView.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/point-of-sale'),
    name: 'point_of_sale',
    component: PointOfSaleView,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
